const replaceUnderscoreWithSpace = (text: string) => text?.replace(/_/g, ' ');

export default replaceUnderscoreWithSpace;
